import { FavoriteJobListPageComponent } from '../pages/favorite-job-list-page/favorite-job-list-page.component';
import { JobListPageComponent } from '../pages/job-list-page/job-list-page.component';
import { JobCreateDialogComponent } from './job-create-dialog/job-create-dialog.component';
import { JobSearchComponent } from './job-search/job-search.component';
import { RegisterStudentDialogComponent } from './register-student-dialog/register-student-dialog.component';

export const JOB_COMPONENTS = [JobListPageComponent, JobSearchComponent, FavoriteJobListPageComponent];

export const JOB_DIALOG_COMPONENTS = [RegisterStudentDialogComponent, JobCreateDialogComponent];
